/**
 * Scout responses sometimes use invalid pseudo-markdown that react-markdown
 * will not turn into links, e.g. "See visit details [/appointments/uuid]"
 * instead of "[visit details](/appointments/uuid)".
 *
 * Valid `[label](url)` spans are preserved first so repair rules cannot corrupt them.
 */
const PRESERVE_OPEN = "\uE000";
const PRESERVE_CLOSE = "\uE001";

export function normalizeScoutChatMarkdown(input: string): string {
    const preserved: string[] = [];
    let s = input.replace(/\[[^\]]+\]\([^)]+\)/g, (match) => {
        preserved.push(match);
        return `${PRESERVE_OPEN}${preserved.length - 1}${PRESERVE_CLOSE}`;
    });

    // Split bracket groups: [label][/relative/path] -> [label](/relative/path)
    s = s.replace(/\[([^\]]+)\]\s*\[(\/[^\]\s]+)\]/g, "[$1]($2)");
    // "See visit details [/appointments/…]" (path in its own brackets)
    s = s.replace(
        /(See\s+)?visit\s+details\s*\[(\/appointments\/[a-f0-9-]+)\]/gi,
        (_match, seePrefix: string | undefined, path: string) =>
            seePrefix ? `${seePrefix.trimEnd()} [visit details](${path})` : `[visit details](${path})`,
    );
    // Remaining path-only brackets: [/appointments/<uuid>]
    s = s.replace(/\[(\/appointments\/[a-f0-9-]{36})\]/gi, "[visit details]($1)");
    // Parens instead of brackets: visit details(/appointments/<uuid>)
    s = s.replace(/\bvisit details\((\/appointments\/[a-f0-9-]{36})\)/gi, "[visit details]($1)");

    s = s.replace(
        new RegExp(`${PRESERVE_OPEN}(\\d+)${PRESERVE_CLOSE}`, "g"),
        (_, i: string) => preserved[Number(i)] ?? "",
    );

    return s;
}
